import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import { getTranslation } from "utils/translations"
import TenantInvoicePosition, { InvoicePositionDistributionRule, InvoicePositionType } from "./TenantInvoicePosition"
import { InvoicePositionProcessingType, InvoicePositionUnit } from "./InvoicePositionBase"

export interface IGetReservationInvoiceInvoicePositionDto {
    id: Guid
    amount: number
    residualAmount?: number | null
    number: string
    text?: string | null
    type?: InvoicePositionType | null
    processingType?: InvoicePositionProcessingType | null
    unit?: InvoicePositionUnit | null
    unitPrice?: number | null
    unitQuantity?: number | null
    start?: string | Dayjs | null
    end?: string | Dayjs | null
    distributionRule: InvoicePositionDistributionRule
}

export default class ReservationInvoiceInvoicePosition {
    id: Guid
    amount: number
    residualAmount: number
    creditedAmount: number
    number: string
    customText?: string
    type?: InvoicePositionType
    processingType?: InvoicePositionProcessingType
    unit?: InvoicePositionUnit
    unitPrice?: number
    unitQuantity?: number
    distributionRule: InvoicePositionDistributionRule
    start?: Dayjs
    end?: Dayjs

    // hydrated separetely
    invoicePosition?: TenantInvoicePosition

    constructor(dto: IGetReservationInvoiceInvoicePositionDto) {
        this.number = dto.number
        this.customText = typeof dto.text === "string" ? dto.text : undefined
        this.type = dto.type || undefined
        this.processingType = dto.processingType || undefined
        this.unit = dto.unit || undefined
        this.unitPrice = dto.unitPrice ?? undefined
        this.unitQuantity = dto.unitQuantity ?? undefined
        this.start = dto.start ? (dayjs.isDayjs(dto.start) ? dto.start : dayjs.utc(dto.start, "YYYY-MM-DD").startOf('date')) : undefined
        this.end = dto.end ? (dayjs.isDayjs(dto.end) ? dto.end : dayjs.utc(dto.end, "YYYY-MM-DD").startOf('date')) : undefined
        this.distributionRule = dto.distributionRule
        this.id = dto.id
        this.amount = dto.amount
        this.residualAmount = dto.residualAmount ?? 0
        this.creditedAmount = this.amount - this.residualAmount
    }

    get isHydrated() {
        return !!this.invoicePosition
    }

    get description(): string {
        if (!this.invoicePosition?.description) return ""
        return getTranslation(this.invoicePosition.description)
    }

    get text(): string {
        if (typeof this.customText === "string") return this.customText
        if (!this.invoicePosition?.text) return ""
        return getTranslation(this.invoicePosition.text)
    }

    set text(text: string | null | undefined) {
        this.customText = text || ""
    }
}
